<template>
    <form @submit.prevent="onSubmit">
        <div class="form__row">
            <div class="form__item">
                <form-input placeholder="Označení jednotky" :v="$v" name="designation" v-model="$v.designation.$model" length-type="w--l" autofocus/>
            </div>
        </div>
        <div class="form__row z1">
            <custom-button type="submit" primary :disabled="processing">
                {{processing ? 'Zakládám...' : 'Založit jednotku'}}
            </custom-button>
        </div>
    </form>
</template>

<script>
import {required, maxLength, minLength} from 'vuelidate/lib/validators';
import FormInput from 'domovio-core/src/components/Form/Input/FormInput';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:        'CreateUnitForm',
    components:  {
        CustomButton,

        FormInput
    },
    props:       {
        processing: {
            type:     Boolean,
            required: false,
            default:  () => false,
        }
    },
    data() {
        return {
            designation: null,
        }
    },
    validations: {
        designation: {
            required,
            minLength: minLength(1),
            maxLength: maxLength(20),
        },
    },
    methods:     {
        onSubmit() {
            this.$v.$touch();
            if (false === this.$v.$invalid) {
                const { designation } = this;
                this.$emit('o3-submit', { designation });
            }
        },
        reset() {
            this.designation = null;
            this.$v.$reset();
        },
        setValues({ designation }) {
            this.designation = designation;
        }
    }
}
</script>
